import React, {useState, useEffect, memo } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
//import Share from "components/Share/Share";
import ImageGallery from 'react-image-gallery';

import carouselStyle from "assets/jss/trip-kit/views/componentsSections/carouselStyle.js";


const useStyles = makeStyles(carouselStyle);

const SectionImages = memo((props) => {
  const [images, setImages] = useState(null);
  const classes = useStyles();
  useEffect(() => {
    setImages(
      props.detailImages && props.detailImages.length >1 ?
      props.detailImages.map(url => ({
          original: `${url.originimgurl ? url.originimgurl.replace('http:', 'https:') : "https://www.tripcheckiner.com/no-image-icon.jpg"}`,
          thumbnail: `${url.smallimageurl ? url.smallimageurl.replace('http:', 'https:') : "https://www.tripcheckiner.com/no-image-icon.jpg"}`
        }))
      :""
    );
  },[props.detailImages]);
  return (
    <div className={classes.section} id="carousel">
      <div className={classes.container}>
        {/*<Share {...props}/>*/}
        <GridContainer>
          <GridItem xs={12} sm={12} md={8} className={classes.marginAuto} style={{marginBottom:"10px",marginTop:"30px"}}>
          {images ? <ImageGallery items={images} showNav={true} lazyLoad={true} autoPlay={false} showPlayButton={false} thumbnailPosition="bottom" /> : null}
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
})
export default SectionImages;
